import * as React from 'react';
import { connect } from 'react-redux';
import injectSheet from 'react-jss';
import { Radio, Tooltip, Icon } from 'antd';
import { withRouter } from 'react-router';
import {
setFilters,
applyFilters,
} from 'src/actions/InquiryFFAction';
import { bindActionCreators } from 'redux';

const styles = theme => ({
  mainDiv: {
    background: 'white',
    position: 'absolute',
    zIndex: 10,
    width: '20%',
    marginTop: '-11px',
    marginLeft:'40%',
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #D9D9D9',
    boxShadow: '2px 2px 2px 0 rgba(0, 0, 0, 0.08)',
    '& .ant-calendar-picker-input': {
      padding: 0,
    },
  },
});

class InquirySortPopup extends React.PureComponent<any, any>
{
  state = {
    value: 1,
  };

  onChange = (e) => {
    this.props.setFilters({
      sortBy: e.target.value,
      descendingOrder: true,
    });
    this.props.applyFilters();
  }

  node: any = React.createRef();

  // const node: any = React.createRef();

  componentWillMount() {
    document.addEventListener('mousedown', this.handleClose, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClose, false);
  }

  handleClose = (e) => {
    if (this.node.contains(e.target)) {
      return;
    }
    this.handleClickOutside();
  }

  handleClickOutside() {
    this.props.closeFilter();
  }

  handleOrder = (val) => {
    val === 'asc' ?
    this.props.setFilters({ descendingOrder : false }) :
    this.props.setFilters({ descendingOrder : true });
    this.props.applyFilters();
  }

  renderOrderIcons() {
    const { appliedFilters } = this.props;
    return <div style={{ display: 'flex', width: '20px', justifyContent: 'space-between' }}>
      <Tooltip placement="top" title="Ascending Order">
      <Icon type="caret-up"
      onClick= {appliedFilters.descendingOrder === true ?
        () => this.handleOrder('asc') : undefined}
      style={{ float:'left', marginTop:'5px', height:'8px', width:'8px',
        color : `${appliedFilters.descendingOrder === true ? '#505050a6' : '#000000'}`}}/>
      </Tooltip>
      <Tooltip placement="top" title="Descending Order">
      <Icon type="caret-down"
      onClick = {appliedFilters.descendingOrder === false ?
        () => this.handleOrder('desc') : undefined}
      style={{ float:'left', marginTop:'5px', height:'8px', width:'8px',
        color : `${appliedFilters.descendingOrder === true ? '#000000' : '#505050a6'}`,
      }}/> </Tooltip>
    </div>;
  }

  render() {
    const radioStyle = {
      display: 'block',
      height: '30px',
      lineHeight: '30px',
    };
    const { classes, appliedFilters } = this.props;
    const option = [['received_date', 'Received Date'],
                     ['deadline', 'Closing Date']];
    return  <div className={classes.mainDiv} ref={node => this.node = node}>
      <Radio.Group onChange={this.onChange} value={this.props.appliedFilters.sortBy}
       disabled={this.props.loading}>
        {option.map((item) => {
          return <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>
              <Radio style={radioStyle} value={item[0]}>
                {item[1]}
              </Radio>
            </div>
            {this.props.appliedFilters.sortBy === item[0]  && !this.props.loading ?
            this.renderOrderIcons() : null}
          </div>;
        })}
      </Radio.Group>
    </div>;
  }
}

const SortPopupStyled = injectSheet(styles)(InquirySortPopup);
const mapStateToProps = ({ inquiryFFReducer }, ownProps) => ({
  filters: inquiryFFReducer.selectedFilters,
  appliedFilters: inquiryFFReducer.appliedFilters,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  setFilters,
  applyFilters,
}, dispatch));
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SortPopupStyled));
